import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SystemSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SystemSettingsQuery = { __typename?: 'Query', systemSettings: { __typename?: 'SystemSettings', preserveCallRecordsFor: number, preserveCcPresenceChangesFor: number } };

export type UpdateSystemSettingsMutationVariables = Types.Exact<{
  preserveCallRecordsFor?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  preserveCcPresenceChangesFor?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UpdateSystemSettingsMutation = { __typename?: 'Mutation', updateSystemSettings: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', type: string, context?: string | null, location: Array<string> }> | null } };


export const SystemSettingsDocument = gql`
    query SystemSettings {
  systemSettings {
    preserveCallRecordsFor
    preserveCcPresenceChangesFor
  }
}
    `;

/**
 * __useSystemSettingsQuery__
 *
 * To run a query within a React component, call `useSystemSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSystemSettingsQuery(baseOptions?: Apollo.QueryHookOptions<SystemSettingsQuery, SystemSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemSettingsQuery, SystemSettingsQueryVariables>(SystemSettingsDocument, options);
      }
export function useSystemSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemSettingsQuery, SystemSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemSettingsQuery, SystemSettingsQueryVariables>(SystemSettingsDocument, options);
        }
export function useSystemSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SystemSettingsQuery, SystemSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SystemSettingsQuery, SystemSettingsQueryVariables>(SystemSettingsDocument, options);
        }
export type SystemSettingsQueryHookResult = ReturnType<typeof useSystemSettingsQuery>;
export type SystemSettingsLazyQueryHookResult = ReturnType<typeof useSystemSettingsLazyQuery>;
export type SystemSettingsSuspenseQueryHookResult = ReturnType<typeof useSystemSettingsSuspenseQuery>;
export type SystemSettingsQueryResult = Apollo.QueryResult<SystemSettingsQuery, SystemSettingsQueryVariables>;
export const UpdateSystemSettingsDocument = gql`
    mutation UpdateSystemSettings($preserveCallRecordsFor: Int, $preserveCcPresenceChangesFor: Int) {
  updateSystemSettings(
    preserveCallRecordsFor: $preserveCallRecordsFor
    preserveCcPresenceChangesFor: $preserveCcPresenceChangesFor
  ) {
    errors {
      type
      context
      location
    }
  }
}
    `;
export type UpdateSystemSettingsMutationFn = Apollo.MutationFunction<UpdateSystemSettingsMutation, UpdateSystemSettingsMutationVariables>;

/**
 * __useUpdateSystemSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSystemSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSystemSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSystemSettingsMutation, { data, loading, error }] = useUpdateSystemSettingsMutation({
 *   variables: {
 *      preserveCallRecordsFor: // value for 'preserveCallRecordsFor'
 *      preserveCcPresenceChangesFor: // value for 'preserveCcPresenceChangesFor'
 *   },
 * });
 */
export function useUpdateSystemSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSystemSettingsMutation, UpdateSystemSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSystemSettingsMutation, UpdateSystemSettingsMutationVariables>(UpdateSystemSettingsDocument, options);
      }
export type UpdateSystemSettingsMutationHookResult = ReturnType<typeof useUpdateSystemSettingsMutation>;
export type UpdateSystemSettingsMutationResult = Apollo.MutationResult<UpdateSystemSettingsMutation>;
export type UpdateSystemSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateSystemSettingsMutation, UpdateSystemSettingsMutationVariables>;